import { render, staticRenderFns } from "./Anina.vue?vue&type=template&id=28d6857e&"
import script from "./Anina.vue?vue&type=script&lang=js&"
export * from "./Anina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports